import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-04d4cee0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { useVModel } from '@vueuse/core';
import { ref, watch, computed } from 'vue';
import { ElMessage } from 'element-plus';
import { savaClinicInfo } from '@/api/tenant';
import EditorCom from '@/components/EditorCom';
import { useStore } from 'vuex';
import { Plus } from '@element-plus/icons-vue';
const Link = "<a style='color:blue;text-decoration:underline;' target='_blank' href='http://api.map.baidu.com/lbsapi/getpoint/index.html'>拾取坐标系统</a>(注意:经纬度之前用;隔开)";

// 内容 HTML

export default {
  __name: 'WxInfo',
  props: {
    // 是否回显数据
    model: {
      type: Object,
      default: null
    },
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:modelValue', 'refreshData', 'clearModel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;

    // 表单元素
    const formEl = ref(null);
    const loading = ref(false);

    // 表单数据
    const formData = ref({
      name: '',
      address: '',
      tel: '',
      businessTime: '',
      coordinates: '',
      traffic: '',
      aboutUs: '',
      reservation: '',
      picture1: '',
      picture2: '',
      picture3: '',
      picture4: ''
    });
    const resetForm = () => {
      formData.value = {
        name: '',
        address: '',
        tel: '',
        businessTime: '',
        coordinates: '',
        traffic: '',
        aboutUs: '',
        reservation: '',
        picture1: '',
        picture2: '',
        picture3: '',
        picture4: ''
      };
      loading.value = false;
      pictureObj.value = {};
    };
    const emits = __emit;
    const isVisible = useVModel(props);

    /** picture arr */
    const pictureObj = ref({});
    watch(() => props.model, val => {
      if (val) {
        resetForm();
        formData.value = {
          id: val.id,
          ...JSON.parse(JSON.stringify(val))
        };
        for (let index = 0; index < 4; index++) {
          if (val[`picUrl${index + 1}`]) {
            val[`picUrl${index + 1}`] && fileList.value.push({
              url: val[`picUrl${index + 1}`]
            });
          }
        }
      } else {
        resetForm();
      }
    }, {
      deep: true,
      immediate: true
    });
    const store = useStore();
    const headers = computed(() => {
      return {
        Authorization: 'Bearer ' + store.getters.token
      };
    });
    const actionUrl = computed(() => {
      return `api/yia/v1/wx_clinic/uploadClinicImage/${props.clinicId}`;
    });
    const fileList = ref([
      // {
      //   name: 'food.jpeg',
      //   url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
      // }
    ]);
    const beforeUpload = rawFile => {
      if (rawFile.type !== 'image/jpeg' && rawFile.type !== 'image/png' && rawFile.type !== 'image/gif') {
        ElMessage.error('上传格式必须为jpeg, png, gif');
        return false;
      } else if (rawFile.size / 1024 / 1024 > 2) {
        ElMessage.error('上传大小不能大于1m');
        return false;
      }
      return true;
    };

    // const handlePlusPicture = (val) => {
    //   console.log(val)
    //   if (primeNum.value > maxPictureNum) return
    //   pictureObj.value[`picture${primeNum.value}`] = {
    //     param: val.param
    //   }
    //   primeNum.value++
    // }

    // const handleMinusPicture = (val) => {
    //   if (primeNum.value < 1) return
    //   delete pictureObj.value[`picture${primeNum.value - 1}`]
    //   primeNum.value--
    //   console.log(pictureObj.value)
    // }

    const handleRemove = (uploadFile, uploadFiles) => {
      fileList.value = uploadFiles;
    };
    const dialogImageUrl = ref('');
    const dialogVisible = ref(false);
    const onUploadSuccessHandler = val => {};
    const handlePictureCardPreview = uploadFile => {
      dialogImageUrl.value = uploadFile.url;
      dialogVisible.value = true;
    };

    /**
     * 新增事件
     */
    const addHandler = async () => {
      for (let index = 0; index < 4; index++) {
        var _fileList$value$index;
        if ((_fileList$value$index = fileList.value[index]) !== null && _fileList$value$index !== void 0 && _fileList$value$index.url) {
          var _fileList$value$index2;
          formData.value[`picUrl${index + 1}`] = ((_fileList$value$index2 = fileList.value[index]) === null || _fileList$value$index2 === void 0 || (_fileList$value$index2 = _fileList$value$index2.response) === null || _fileList$value$index2 === void 0 ? void 0 : _fileList$value$index2.data) || fileList.value[index].url;
        } else {
          formData.value[`picUrl${index + 1}`] = '';
        }
      }
      if (!formEl.value) return;
      await formEl.value.validate(async (valid, fields) => {
        if (valid) {
          loading.value = true;
          try {
            if (props.model) {
              await savaClinicInfo({
                ...formData.value
              });
            } else {
              await savaClinicInfo({
                ...formData.value
              });
            }
            loading.value = false;
            emits('refreshData');
            ElMessage({
              type: 'success',
              message: props.model ? '修改成功' : '添加成功'
            });
          } catch (error) {} finally {
            isVisible.value = false;
          }
        } else {
          ElMessage({
            type: 'error',
            message: '验证失败'
          });
        }
      });
    };
    const closed = () => {
      formEl.value.resetFields();
      fileList.value = [];
      resetForm();
      if (props.model) {
        emits('clearModel');
      }
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        title: __props.model ? '修改诊所信息' : '新增诊所信息',
        width: "60%",
        onClosed: closed,
        "destroy-on-close": "",
        class: "dialog-class",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = $event => isVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: addHandler,
          loading: loading.value
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "150px",
          model: formData.value,
          style: {
            "max-width": "90%"
          },
          ref_key: "formEl",
          ref: formEl
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "诊所名称：",
            prop: "packName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.name = $event),
              placeholder: "请输入诊所名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "诊所地址：",
            prop: "packName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.address,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.address = $event),
              placeholder: "请输入诊所地址"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "客服热线：",
            prop: "tel"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.tel,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value.tel = $event),
              placeholder: "请输入客服热线"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "营业时间：",
            prop: "tel"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.businessTime,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.value.businessTime = $event),
              placeholder: "请输入营业时间"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "地图坐标",
            prop: "coordinates"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.coordinates,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.value.coordinates = $event),
              placeholder: "请输入地图坐标"
            }, null, 8, ["modelValue"]), _createElementVNode("div", {
              innerHTML: Link
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "诊所预约提示消息",
            prop: "reservation"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              rows: 3,
              type: "textarea",
              modelValue: formData.value.reservation,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.value.reservation = $event),
              maxlength: 100,
              placeholder: "请输入诊所预约提示消息"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "交通路线："
          }, {
            default: _withCtx(() => [_createVNode(_unref(EditorCom), {
              modelValue: formData.value.traffic,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formData.value.traffic = $event),
              width: "100%",
              height: "300"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "关于我们："
          }, {
            default: _withCtx(() => [_createVNode(_unref(EditorCom), {
              modelValue: formData.value.aboutUs,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => formData.value.aboutUs = $event),
              width: "100%",
              height: "300"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "图片："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_upload, {
              "file-list": fileList.value,
              "onUpdate:fileList": _cache[8] || (_cache[8] = $event => fileList.value = $event),
              action: actionUrl.value,
              "list-type": "picture-card",
              "on-remove": handleRemove,
              headers: headers.value,
              limit: 4,
              "on-preview": handlePictureCardPreview,
              "on-success": onUploadSuccessHandler,
              "before-upload": beforeUpload
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(Plus))]),
                _: 1
              })]),
              _: 1
            }, 8, ["file-list", "action", "headers"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};